exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".comments__empty{text-align:center}.comments__tabs{width:100%}@media print{.comments__empty{display:none}.comments__tabs{display:none}}\n", ""]);

// exports
exports.locals = {
	"comments__empty": "comments__empty",
	"comments__tabs": "comments__tabs"
};